import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type { OrderSummaryDto } from './types';

export interface SyncOrderLineDto {
  orderLineId: string;
  itemId: string;
  itemNameSnapshot: string;
  unitPriceSnapshot: number;
  quantity: number;
  lineDiscount: number;
  notes: string | null;
  modifiers: never[];
  courseNumber: number;
}

export interface SyncOrderRequestDto {
  orderId: string;
  localOrderNumber: string;
  branchId: string;
  cashierUserId: string;
  shiftId: string | null;
  customerId: string | null;
  orderType: number;
  status: number;
  subtotal: number;
  taxTotal: number;
  discountTotal: number;
  total: number;
  openedAt: string;
  placedAt: string | null;
  paidAt: string | null;
  voidedAt: string | null;
  voidReason: string | null;
  restaurantTableId: string | null;
  lines: SyncOrderLineDto[];
  payments: never[];
}

export function useOrdersByCustomer(customerId: string | null) {
  return useQuery({
    queryKey: ['orders', 'by-customer', customerId] as const,
    enabled: !!customerId,
    queryFn: async () =>
      (await apiClient.get<OrderSummaryDto[]>(`/api/orders/by-customer/${customerId}`))
        .data,
  });
}

export function useSubmitPhoneOrder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (req: SyncOrderRequestDto) =>
      (await apiClient.post('/api/sync/orders', req)).data,
    onSuccess: (_data, vars) => {
      if (vars.customerId) {
        qc.invalidateQueries({
          queryKey: ['orders', 'by-customer', vars.customerId],
        });
      }
    },
  });
}
